export default "__VITE_ASSET__d95745d0__"